<template>
  <div>
    <div>
      <el-select
        :value="materialSelect"
        clearable
        @input="handleChangeMaterialCode($event)"
        filterable
        remote
        :remote-method="data => handleSearchMaterial('code', data)"
        :disabled="disabled"
        style="width: 100%"
      >
        <el-option
          v-for="p in materialCodeDropdown"
          :value="p.code"
          :label="p.code_description_unit"
          :key="p.code"
          >{{ p.code_description_unit }}</el-option
        >
      </el-select>
    </div>
    <div
      class="dialog-bg"
      @click.self="onConfirm(false)"
      v-if="isShowCreateMaterialCode"
    >
      <div class="dialog-box">
        <div class="header mb-3">สร้าง Material Code ใหม่</div>
        <div class="row mb-3">
          <div class="col-5">
            <label class="label">Material group</label>
            <el-select
              v-model="materialGroupSelect"
              class="input"
              clearable
              filterable
              remote
              :remote-method="data => handleSearchMaterial('group', data)"
              style="width: 100%"
            >
              <el-option
                v-for="p in materialGroupDropdown"
                :value="p.id"
                :label="p.code_name"
                :key="p.id"
                >{{ p.code_name }}</el-option
              >
            </el-select>
          </div>
          <div class="col-7">
            <label class="label"
              >Material name ({{ meterialName ? meterialName.length : 0 }}/40)</label
            >
            <el-input class="input" v-model="meterialName"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label class="label">หน่วยนับของสินค้า/บริการ</label>
            <el-select
              v-model="materialUnitSelect"
              class="input"
              clearable
              filterable
              remote
              :remote-method="data => handleSearchMaterial('unit', data)"
              style="width: 100%"
            >
              <el-option
                v-for="p in materialUnitDropdown"
                :value="p.id"
                :label="p.unit"
                :key="p.id"
                >{{ p.unit }}</el-option
              >
            </el-select>
          </div>
          <div class="col-7 mt-4">
            <label class="select-input">
              <span>ต้องสต็อกสินค้า</span>
              <input
                type="radio"
                :value="true"
                name="type"
                v-model="isInventoryUpdate"
              />
              <span class="checkmark radio"></span>
            </label>
            <label class="select-input">
              <span>ไม่ต้องสต็อกสินค้า</span>
              <input
                type="radio"
                :value="false"
                name="type"
                v-model="isInventoryUpdate"
              />
              <span class="checkmark radio"></span>
            </label>
          </div>
        </div>
        <div class="text-right mt-5">
          <sc-button variant="danger" @click="handleClickCancel"
            >ยกเลิก</sc-button
          >
          <sc-button variant="primary" @click="handleClickSave"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Select, Option, Checkbox } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";

export default {
  props: ["value", "disabled"],
  components: {
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    ScButton,
  },
  data() {
    return {
      isShowCreateMaterialCode: false,
      materialGroupSelect: null,
      materialUnitSelect: null,
      meterialName: null,
      materialGroupList: [],
      materialGroupChangingDropdown: null,
      materialCodeChangingDropdown: null,
      materialCodeList: [],
      materialUnitList: [],
      materialUnitChangingDropdown: null,
      isInventoryUpdate: false
    };
  },
  computed: {
    materialSelect() {
      return this.value;
    },
    materialGroupDropdown() {
      return this.materialGroupChangingDropdown
        ? this.materialGroupChangingDropdown
        : this.materialGroupList;
    },
    materialCodeDropdown() {
      return this.materialCodeChangingDropdown
        ? this.materialCodeChangingDropdown
        : this.materialCodeList;
    },
    materialUnitDropdown() {
      return this.materialUnitChangingDropdown
        ? this.materialUnitChangingDropdown
        : this.materialUnitList;
    }
  },
  watch: {
    materialGroupSelect() {
      this.materialGroupChangingDropdown = null;
    },
    materialUnitSelect() {
      this.materialUnitChangingDropdown = null;
    },
    meterialName(newValue, oldValue) {
      if (newValue && newValue.length > 40) {
        this.meterialName = oldValue;
      }
    },
    value(newValue) {
      this.findUnitName(newValue);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupMaterialCode();
      await this.setupMaterialGroup();
      await this.setupMaterialUnit();
    },
    async setupMaterialCode() {
      const response = await baanRueJaiClient.admin.sap.codeList();
      const matCodeList = response.data.result.materials;
      const materialArrayForAddMatCode = [{ code: "addMaterialCode", code_description_unit: "+ สร้างใหม่" }];

      this.materialCodeList = materialArrayForAddMatCode.concat(matCodeList);
    },
    async setupMaterialGroup() {
      const response = await baanRueJaiClient.admin.sap.groupList();
      const matGroupList = response.data.result.materials;
      
      this.materialGroupList = matGroupList;
    },
    async setupMaterialUnit() {
      const response = await baanRueJaiClient.admin.sap.unitList();
      const matGroupList = response.data.result.materials;
      
      this.materialUnitList = matGroupList;
    },
    handleChangeMaterialCode(materialCode) {
      if (materialCode === "addMaterialCode") {
        this.isShowCreateMaterialCode = true;
      } else {
        this.$emit("input", materialCode);

        this.materialCodeChangingDropdown = null;
      }
    },
    onConfirm(action) {
      this.$emit("confirm", action);
    },
    async handleClickSave() {
      if (!this.materialGroupSelect) {
        alert('กรุณาเลือก Material group');
        return
      }

      if (!this.materialUnitSelect) {
        alert('กรุณาเลือก หน่วยนับของสินค้า/บริการ');
        return
      }

      if (!this.meterialName) {
        alert('กรุณากรอก Material name');
        return
      }

      try {
        await this.createMaterialCode();
        await this.setupMaterialCode();

        alert('บันทึกเสร็จสิ้น');
        this.handleClickCancel();
      } catch (err) {
        if (
          err.response
          && err.response.status === 400
          && err.response.data
          && err.response.data.message
        ) {
          alert(err.response.data.message);
          console.error(err);
        } else {
          alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
          console.error(err);
        }
      }
    },
    async createMaterialCode() {
      const params = {
        group_id: +this.materialGroupSelect,
        unit_id: this.materialUnitSelect,
        name: this.meterialName,
        is_inventory_update: this.isInventoryUpdate
      };

      await baanRueJaiClient.admin.sap.postMaterialCode(params);
    },
    handleClickCancel() {
      this.materialGroupSelect = null;
      this.materialUnitSelect = null;
      this.meterialName = null;

      this.isShowCreateMaterialCode = false;
    },
    handleSearchMaterial(key, value) {
      if (key === "group") {
        this.materialGroupChangingDropdown = this.materialGroupList.filter((item) => {
          return item.code_name.toUpperCase().includes(value.toUpperCase());
        });
      }

      if (key === 'code') {
        this.materialCodeChangingDropdown = this.materialCodeList.filter((item) => {
          return item.code_description_unit.toUpperCase().includes(value.toUpperCase());
        });
      }

      if (key === 'unit') {
        this.materialUnitChangingDropdown = this.materialUnitList.filter((item) => {
          return item.unit.toUpperCase().includes(value.toUpperCase());
        });
      }
    },
    async findUnitName(material) {
      if (!this.materialCodeList || this.materialCodeList.length === 0) {
        this.$emit("unitName", null);
        return
      };

      const materialSelected = this.materialCodeList.find(
        (materialCode) => materialCode.code === material
      );

      if (!materialSelected) {
        this.$emit("unitName", null);
        return
      };

      const materialSelectedSplitString = materialSelected.code_description_unit.split(" ");
      const unitName = materialSelectedSplitString[materialSelectedSplitString.length - 1];

      this.$emit("unitName", { unitName, codeDescriptionUnit: materialSelected.code_description_unit });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.dialog-box {
  top: 50%;
  left: 50%;
  width: 750px;
  height: 380px;
  position: absolute;
  background: #fcfcfc 0% 0% no-repeat padding-box;
  border-radius: 24px;
  padding: 20px;
  transform: translate(-50%, -50%);
  overflow-x: auto;
}

.header {
  line-height: 1.6;
  font-size: 26px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/lib/components/materialSelector.vue